import { createSlice } from "@reduxjs/toolkit"

const applicationSlice = createSlice({
  name: "application",
  initialState: {
    applicationList: [],
    appCode: "",
    loading: false,
    refetchApplicationList: false,
  },
  reducers: {
    getApplications(state) {
      return {
        ...state,
        loading: true,
        refetchApplicationList: false,
      }
    },
    getApplicationsSuccess(state, action) {
      return {
        ...state,
        applicationList: action.payload.data,
        loading: false,
        refetchApplicationList: false,
      }
    },
    setAppCode(state, action) {
      return {
        ...state,
        appCode: action?.payload?.appCode,
      }
    },
    createApplications(state) {
      return {
        ...state,
        loading: true,
        refetchApplicationList: false,
      }
    },
    createApplicationsSuccess(state, action) {
      return {
        ...state,
        loading: false,
        refetchApplicationList: true,
      }
    },
    updateApplications(state) {
      return {
        ...state,
        loading: true,
        refetchApplicationList: false,
      }
    },
    updateApplicationsSuccess(state, action) {
      return {
        ...state,
        loading: false,
        refetchApplicationList: true,
      }
    },
    deleteApplication(state) {
      return {
        ...state,
        loading: true,
        refetchApplicationList: false,
      }
    },
    deleteApplicationSuccess(state, action) {
      return {
        ...state,
        loading: false,
        refetchApplicationList: true,
      }
    },
  },
})

export const {
  getApplications,
  getApplicationsSuccess,
  deleteApplication,
  deleteApplicationSuccess,
  createApplications,
  createApplicationsSuccess,
  updateApplications,
  updateApplicationsSuccess,
  setAppCode,
} = applicationSlice.actions

export default applicationSlice.reducer
